#import "./TrainingModuleAdminFields.graphql"

mutation UpdateTrainingModule(
  $moduleId: ID!
  $moduleInput: TrainingModuleInput!
) {
  updateTrainingModule(
    input: { moduleId: $moduleId, moduleInput: $moduleInput }
  ) {
    trainingModule {
      ...TrainingModuleAdminFields
    }
  }
}
